/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveNotificationActionData
 */
export interface SaveNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationActionData
     */
    type: SaveNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationActionData
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationActionData
     */
    saveItemId: string;
}


/**
 * @export
 */
export const SaveNotificationActionDataTypeEnum = {
    Track: 'track',
    Playlist: 'playlist',
    Album: 'album'
} as const;
export type SaveNotificationActionDataTypeEnum = typeof SaveNotificationActionDataTypeEnum[keyof typeof SaveNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the SaveNotificationActionData interface.
 */
export function instanceOfSaveNotificationActionData(value: object): value is SaveNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "saveItemId" in value && value["saveItemId"] !== undefined;

    return isInstance;
}

export function SaveNotificationActionDataFromJSON(json: any): SaveNotificationActionData {
    return SaveNotificationActionDataFromJSONTyped(json, false);
}

export function SaveNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'userId': json['user_id'],
        'saveItemId': json['save_item_id'],
    };
}

export function SaveNotificationActionDataToJSON(value?: SaveNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'user_id': value.userId,
        'save_item_id': value.saveItemId,
    };
}

